<template>
  <!--
    No top margin. The page above and the footer are both #eaeed3, but a margin
    between them is transparent, so the white <body> showed through as a band
    across the full width. The border-top and the internal padding give all the
    separation this needs.
  -->
  <footer
    class="tw-border-t"
    style="background-color: #eaeed3; border-color: rgba(52, 106, 126, 0.2)"
  >
    <div class="tw-mx-auto tw-max-w-6xl tw-px-6 tw-py-12">
      <div class="tw-grid tw-gap-10 sm:tw-grid-cols-2 lg:tw-grid-cols-4">
        <div class="lg:tw-col-span-2">
          <img
            src="/logo.png"
            alt="Green Medicine Works"
            width="48"
            height="48"
            class="tw-h-12 tw-w-auto"
          />
          <p
            class="tw-mt-4 tw-max-w-md tw-text-sm tw-leading-relaxed"
            style="color: #234d5b"
          >
            A science-based encyclopedia of nutrition and natural medicine —
            evidence-linked topics covering vitamins, minerals, herbs, foods and
            the conditions they affect.
          </p>
        </div>

        <div v-for="group in groups" :key="group.title">
          <h2
            class="tw-text-sm tw-font-semibold tw-uppercase tw-tracking-wide"
            style="color: #346a7e"
          >
            {{ group.title }}
          </h2>
          <ul role="list" class="tw-mt-4 tw-space-y-2.5">
            <li v-for="link in group.links" :key="link.href">
              <router-link
                :to="link.href"
                class="tw-text-sm tw-no-underline hover:tw-underline"
                style="color: #234d5b"
              >
                {{ link.label }}
              </router-link>
            </li>
          </ul>
        </div>
      </div>

      <div
        class="tw-mt-10 tw-border-t tw-pt-6 tw-text-sm"
        style="border-color: rgba(52, 106, 126, 0.2); color: #4a6b78"
      >
        {{ new Date().getFullYear() }} © Green Medicine Works. Information here
        is for education and is not medical advice.
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
/**
 * Footer for the public (crawlable) layout.
 *
 * `layouts/public.vue` referenced a `<PublicFooter />` that was never written,
 * so it silently resolved to nothing and every /preview/:id page rendered with
 * no footer, no branding and no way out except the back button.
 *
 * The link groups double as internal linking: preview pages are otherwise
 * orphans reachable only from the sitemap, and a crawler arriving on one had
 * no path to /plans or /about.
 */
interface FooterLink {
  label: string;
  href: string;
}

const groups: { title: string; links: FooterLink[] }[] = [
  {
    title: "Explore",
    links: [
      { label: "Home", href: "/" },
      { label: "About", href: "/about" },
      { label: "Plans & pricing", href: "/plans" },
    ],
  },
  {
    title: "Get started",
    links: [
      { label: "Start a free trial", href: "/register/trial" },
      { label: "Log in", href: "/auth/login" },
      { label: "Privacy policy", href: "/privacy/policy" },
      { label: "Terms of service", href: "/terms/service" },
    ],
  },
];
</script>
